import styled from 'styled-components'

export const StyledTripLegDocumentSuccess = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: ${props => props.theme.spacing.large};

  & > div {
    color: ${props => props.theme.colors.success[500]};
  }
`
